import React from "react";
import logo from "./header_section/logo1.png";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { RiFacebookFill } from "react-icons/ri";
import { BsThreads } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="py-12  shadow-2xl bg-[#e2eff7] text-gray-700">
      <div className="container w-full mx-auto px-3">
        {/* Logo Section */}
        <div className="flex justify-center mb-8">
          <img
            src={logo}
            alt="Versai Tech Solutions Logo"
            className="w-40 h-auto"
          />
        </div>

        {/* Main Content */}
        <div className="grid gap-8 sm:gap-x-5  lg:gap-x-20 w-full mx-auto  md:grid-cols-5">
          {/* Left Section - Our Vision */}
          <div className=" xl:ps-5 md:col-span-2 text-center sm:text-left">
            <h2 className="text-2xl font-bold mb-4">Our Vision</h2>
            <p className="md:text-justify xl:text-left">
              Versai Tech Solutions is a pioneer in providing comprehensive
              services in website development, app development, and digital
              marketing. We understand the ever-growing demands of today’s
              digital landscape and strive to deliver innovative solutions that
              drive sustained growth for enterprises across various industries.
            </p>
          </div>

          {/* Middle Section - Contact Us */}
          <div className="tracking-widest text-center  sm:text-left">
            <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
            <div className="flex flex-col items-center sm:items-start">
              <div className="flex items-center mb-2 gap-2">
                <ion-icon name="call"></ion-icon>
                <span className="font-bold">
                  <a
                    href="tel:7597683262"
                    className="text-blue-500 hover:underline"
                  >
                    Get in touch
                  </a>
                </span>
              </div>
              <div className="flex items-center mb-2">
                <FaEnvelope className="mr-2" />
                <span className="font-bold">
                  <a
                    href="mailto:info@versai.in"
                    className="text-blue-500 hover:underline"
                  >
                    Mail us
                  </a>
                </span>
              </div>
              <div className="flex items-center mb-2">
                <FaMapMarkerAlt className="mr-2" />
                <span className="font-bold">Address:</span>
              </div>
              <p>
                Ajitgarh,
                <br />
                Jhunjhunu,
                <br />
                <b>Rajasthan</b>
              </p>
              <p className="font-bold">Pincode: 333701</p>
            </div>
          </div>

          {/* Right Section - Company Info */}
          <div className="tracking-widest text-center sm:text-left">
            <h2 className="text-2xl font-bold mb-4">Company</h2>
            <ul>
              <Link
                to="/About-us"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">About Us</li>
              </Link>
              <Link
                to="/Career"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">Career</li>
              </Link>
              <Link
                to="/Contact-us"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">Contact Us</li>
              </Link>
            </ul>
          </div>

          {/* Right Section - Support Info */}
          <div className="tracking-widest text-center sm:text-left">
            <h2 className="text-2xl font-bold  mb-4">Support</h2>
            <ul>
              <Link
                to="/Privacy-policy"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">Privacy Policy</li>
              </Link>
              <Link
                to="/Term-and-condition"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">
                  Terms and Conditions
                </li>
              </Link>
              <Link
                to="/Refund"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">
                  Cancellation and Refund
                </li>
              </Link>
              <Link
                to="/Faqs"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <li className="mb-2 hover:text-gray-900">FAQ</li>
              </Link>
            </ul>
          </div>
          {/* <div className="tracking-widest text-center sm:text-left">
  <h2 className="text-2xl font-bold mb-4">Support</h2>
  <ul>
    {[
      { path: "/Privacy-policy", label: "Privacy Policy" },
      { path: "/Term-and-condition", label: "Terms and Conditions" },
      { path: "/Refund", label: "Cancellation and Refund" },
      { path: "/Faqs", label: "FAQ" },
    ].map((item, index) => (
      <Link
        key={index}
        to={item.path}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <li className="mb-2 group">
          <span className="relative hover:text-gray-900 group-hover:text-gray-900 transition-all duration-300">
            {item.label}
            <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
          </span>
        </li>
      </Link>
    ))}
  </ul>
</div> */}
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center mt-8">
          <a
            href="https://x.com/Versai_Tech"
            className="mx-2 text-2xl xl:text-3xl hover:text-gray-800 text-gray-500 "
            target="_Blank"
            rel="noreferrer"
          >
            <FaXTwitter />
          </a>
          <a
            href="https://www.linkedin.com/company/versai-tech-solution/"
            className="mx-2 text-2xl xl:text-3xl text-gray-500 hover:text-[#1469c7]"
            target="_Blank"
            rel="noreferrer"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.instagram.com/versai.in/"
            className="mx-2 text-2xl xl:text-3xl text-gray-500 hover:text-[#ec0866]"
            target="_Blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.threads.com/@versai.in"
            className="mx-2  text-2xl xl:text-3xl text-gray-500 hover:text-black"
            target="_Blank"
            rel="noreferrer"
          >
            <BsThreads />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61567734179772"
            className="mx-2  text-2xl xl:text-3xl text-gray-500 hover:text-[#1469c7]"
            target="_Blank"
            rel="noreferrer"
          >
            <RiFacebookFill />
          </a>
          <a
            href="https://whatsapp.com/channel/0029Vb2LjjMLI8YSCHngZZ0L"
            className="mx-2 text-2xl xl:text-3xl text-gray-500 hover:text-green-700"
            target="_Blank"
            rel="noreferrer"
          >
            <FaWhatsapp />
          </a>
         
        </div>

        {/* Footer Bottom - Copyright */}
        <div className="text-center mt-8">
          <p className="text-gray-500">
            &copy; 2025{" "}
            <span className="text-orange-500">Versai Digital Solutions Private Limited</span>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
